import { render, staticRenderFns } from "./SvgIcon.vue?vue&type=template&id=2843352c"
import script from "./SvgIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./SvgIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports